<template>
  <div class="global-content-box">
    <y-menu-title />
    <!-- 1.查询区域 -->
    <div class="form-content">
      <div class="item">
        <label style="font-size: 12px; color: #666666; line-height: 32px"
          >店铺名称：</label
        >

        <el-select
          class="select-shop"
          v-model="selectedOptions"
          placeholder="默认所有店铺"
          collapse-tags
          multiple
          filterable
        >
          <el-option
            v-for="item in formDataList"
            :key="item.channelSellerManageId"
            :label="item.shopTitle"
            :value="item.channelSellerManageId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <y-button
          type="blue"
          class="search"
          @click="search"
          :disabled="talbeLoading"
          >查询</y-button
        >
        <y-button type="default" @click="getClean" :disabled="talbeLoading"
          >重置</y-button
        >
      </div>
    </div>

    <div class="item">
      <y-button
        class="add"
        type="blue"
        @click="addManage"
        v-if="checkPermission('新建会员体系')"
        >新增会员体系</y-button
      >
    </div>
    <!-- 2.卡片区域 -->
    <div class="card-content" v-loading="talbeLoading">
      <el-row :gutter="20">
        <template v-for="(item, index) in restaurants">
          <el-col :span="6" :key="index + '@'" class="card-box" style="">
            <div class="card">
              <div class="item item-wrap">
                <el-popover
                  v-if="item.cardName && item.cardName.length > 10"
                  placement="top-start"
                  trigger="hover"
                  width="200"
                  :content="item.cardName"
                  class="text1"
                >
                  <div slot="reference" class="text1">
                    {{ item.cardName }}
                  </div>
                </el-popover>
                <div v-else class="text1">{{ item.cardName }}</div>
                <div class="flexc-cen-x">
                  <el-tooltip
                    class="i"
                    placement="bottom"
                    width=""
                    effect="dark"
                    trigger="hover"
                    content=" 请前往"
                    popper-class="custom-tooltip"
                  >
                    <template #content>
                      <span style="">暂未设置基础积分规则，如需设置 </span>
                      <span
                        @click="jumpRule(item)"
                        style="
                          cursor: pointer;
                          color: #00ffd0;
                          text-decoration: underline;
                        "
                      >
                        请前往</span
                      >
                    </template>
                    <img
                      v-if="item.isSetBaseScoresRule == 0"
                      src="@/assets/images/路径 4028.svg"
                      alt
                    />
                  </el-tooltip>
                  <div>
                    <el-button
                      class="onbtn"
                      v-if="item.openFlag == 1"
                      >已开启</el-button
                    >
                    <el-button
                      class="offbtn"
                      v-else
                      >未开启</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="text2">适用店铺：</div>
                <div class="text2">
                  <span>{{ item.shopSum }}个</span>
                </div>
              </div>

              <div class="item">
                <el-tooltip
                  v-if="
                    item.sellerNickListStr && item.sellerNickListStr.length > 15
                  "
                  placement="top-end"
                  trigger="hover"
                  class="text3"
                  effect="dark"
                >
                  <div slot="content" style="width: 200px; font-size: 12px">
                    {{ item.sellerNickListStr }}
                  </div>
                  <div class="text33">
                    {{ item.sellerNickListStr }}
                  </div>
                </el-tooltip>
                <div class="text3" v-else>
                  {{ item.sellerNickListStr ? item.sellerNickListStr : "--" }}
                </div>
              </div>
              <div class="item">
                <el-tooltip
                  v-if="item.remark && item.remark.length > 15"
                  placement="top-end"
                  trigger="hover"
                  width="200"
                  class="text4"
                  effect="dark"
                >
                  <div slot="content" style="width: 200px; font-size: 12px">
                    {{ item.remark }}
                  </div>
                  <div class="text44">备注：{{ item.remark }}</div>
                </el-tooltip>
                <div class="text4" v-else>
                  备注：{{ item.remark ? item.remark : "--" }}
                </div>
              </div>
              <div class="item">
                <y-button
                  type="blueLine"
                  class="onmanage"
                  @click="jumpTotal(item)"
                  v-if="checkPermission('会员信息管理', '会员总览')"
                  :disabled="item.connectMode != 1"
                  >管理</y-button
                >
                <y-button
                  type="default"
                  class="edit"
                  @click="edit(item)"
                  v-if="checkPermission('忠诚度管理', '会员体系设置')"
                  :disabled="item.connectMode != 1"
                  >编辑</y-button
                >
              </div>
              <div class="mode">
                <img
                  v-if="item.connectMode == 1"
                  class="mode-img"
                  src="@/assets/images/memberAll/center_mode.svg"
                  alt=""
                />
                <img
                  v-else-if="item.connectMode == 0"
                  class="mode-img"
                  src="@/assets/images/memberAll/router_mode.svg"
                  alt=""
                />
                <img
                  v-else-if="item.connectMode == 2"
                  class="mode-img"
                  src="@/assets/images/memberAll/yz_router_mode.svg"
                  alt=""
                />
              </div>
            </div>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import router from "../../router";
import {
  getScoresCardList,
  getMyList,
  scoresCardFlag,
} from "@/api/membershipSystem";
import { checkSellerOwnRorNot } from "@/api/public";
export default {
  components: {},
  name: "membership-system",
  data() {
    return {
      openFlag: 0,
      talbeLoading: false,
      // 下拉框模糊搜索输入框
      state: "",
      // 下拉框多选
      selectedOptions: [],
      // 卡片区域数组
      restaurants: [],
      // 管理按钮禁用
      disabled: true,
      // 店铺名称 -查询区域
      shopName: [], //数组对象
      value: "",
      formDataList: [],
      newIds: [], // 权限
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员体系列表", "会员体系列表");
    // 进入页面隐藏部分菜单
    this.$store.state.isMemberSystemInfo = false;
    // 清空储存的会员体系信息
    this.$store.state.MemberSystemInfo = {};
  },
  mounted() {
    // 获取绑定店铺列表（含过期的）
    this.getMyList();
    // 获取卡片列表
    this.getScoresCardList();
    checkSellerOwnRorNot({ ids: "88,92" }).then((res) => {
      if (res.code == 200) {
        this.newIds = res.data;
      }
    });
  },
  methods: {
    ...mapMutations({
      setIsIframe: 'setIsIframe',
    }),
    // 菜单判断
    checkPermission(fatherName, name = null) {
      let isHave = false;
      let fatherList = this.$store.getters.fistMenuList;
      let childrenList = this.$store.getters.childMenuList;
      let fatherIndex = fatherList.findIndex(
        (item) => item.name === "忠诚度管理"
      );
      let childrenData = childrenList[fatherIndex] || [];
      let childrenIndex = childrenData.findIndex(
        (item) => item.name === fatherName
      );
      if (name) {
        let menuData = childrenData[childrenIndex] || { children: [] };
        if (!!menuData.children && menuData.children.length > 0) {
          menuData.children.forEach((item) => {
            if (item.name === name) {
              isHave = true;
            }
          });
        } else {
          isHave = false;
        }
      } else {
        if (childrenIndex != -1) isHave = true;
      }
      return isHave;
    },
    // 1.获取数据
    getScoresCardList() {
      this.talbeLoading = true;
      getScoresCardList(this.selectedOptions).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.restaurants = res.data;
        }
      });
    },
    // 2.获取下拉框列表
    getMyList() {
      getMyList().then((res) => {
        if (res.code == 200) {
          this.formDataList = res.data;
          this.selectedOptions = [];
          // res.data.forEach((item) => {
          //   this.selectedOptions.push(item.channelSellerManageId);
          // });
        }
      });
    },
    // 3.卡片 开启/关闭状态切换
    openFlag1(scoresCardId, openFlag) {
      if (openFlag == 1) {
        openFlag = 0;
      } else {
        openFlag = 1;
      }
      scoresCardFlag({ scoresCardId, openFlag })
        .then((res) => {
          if (res.code == 200) {
            this.getScoresCardList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error);
        });
    },
    // 4.查询按钮
    search() {
      this.getScoresCardList(this.selectedOptions);
    },
    // 5.管理按钮-跳转
    jumpTotal(val) {
      // 判断权限
      if (!this.newIds.includes("88")) return this.$message.warning("暂无权限");
      // 点击管理按钮时，跳转到会员信息管理-会员总览页面
      this.$store.state.MemberSystemInfo = val;
      this.$store.state.isMemberSystemInfo = true;
      router.push("/loyaltyManagement/memberMessageSystem/memberAll");
    },
    // 6.点击编辑-跳转
    edit(val) {
      // 判断权限
      if (!this.newIds.includes("92")) return this.$message.warning("暂无权限");
      // 点击编辑按钮时，跳转到会员体系设置
      this.$store.state.MemberSystemInfo = val;
      this.$store.state.isMemberSystemInfo = true;
      router.push(
        "/loyaltyManagement/loyaltyManagement/set_member_ship_system"
      );
    },
    // 7.点击新增会员体系按钮
    addManage() {
      // 点击新增按钮时，跳转到新建会员体系
      router.push("/loyaltyManagement/newMembershipSystem");
    },
    // 8.点击 请前往 时
    jumpRule(val) {
      if (!this.checkPermission("忠诚度管理", "积分发放规则")) {
        this.$message.warning("无对应权限，可联系您的专属业务帮您解决问题哦~");
        return;
      } else {
        // 点击请前往时，跳转到忠诚度管理-积分发放规则
        this.$store.state.MemberSystemInfo = val;
        this.$store.state.isMemberSystemInfo = true;
        router.push(
          "/loyaltyManagement/loyaltyManagement/points_distribution_rules"
        );
      }
    },
    // 9.重置
    getClean() {
      this.getMyList();
      setTimeout(() => {
        this.getScoresCardList();
      }, 1000);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const isIframe = vm.$route.query.isIframe;
      if (isIframe) {
        vm.setIsIframe(true);
      }
    })
  }
};
</script>

<style scoped lang="scss">
.select-shop {
  width: 300px;
  /deep/ .el-select__tags {
    max-width: 145px !important;
  }
  /deep/ .el-select__input {
    width: 80px !important;
    padding-right: 30px;
  }
  /deep/ .el-select__tags {
    flex-wrap: nowrap !important;
  }
}
.form-content {
  display: flex;
}

.card {
  position: relative;
}

.item {
  display: flex;
  &-mode {
    margin-left: 8px;
  }
  .search {
    margin-left: 30px;
  }
  .reset {
    width: 88px;
    height: 32px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #1f4287;
  }
  .add {
    margin-top: 16px;
    // width: 112px;
    // height: 32px;
    // background: #1f4287;
    // border-radius: 6px 6px 6px 6px;
  }
  .text1 {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
  }
  .i {
    margin-right: 12px;
  }
  .text2 {
    margin-top: 24px;
    font-size: 14px;
    color: #999999;
    span {
      font-size: 14px;
      color: $theme-color;
    }
  }
  .popover {
    .text3 {
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
    }
  }
  .text3 {
    margin-top: 12px;
    font-size: 14px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    .text33 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
    }
  }
  .text4 {
    margin-top: 14px;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    .text44 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
    }
  }
  .onmanage {
    margin-top: 30px;
    // width: 60px;
    // min-width: 60px;
    // height: 32px;
    // background: #1f4287;
    // border-radius: 6px;
    // color: #ffffff;
    // font-size: 14px;
  }
  .offmanage {
    margin-top: 30px;
    width: 60px;
    min-width: 60px;
    height: 32px;
    background: #cccccc;
    border-radius: 6px;
    color: #ffffff;
    font-size: 14px;
  }
  .edit {
    margin-left: 8px;
    margin-top: 30px;
    // width: 60px;
    // min-width: 60px;
    // height: 32px;
    // background: #ffffff;
    // border-radius: 6px;
    // color: #1f4287;
    // font-size: 14px;
  }
}

.mode {
  position: absolute;
  right: 0px;
  bottom: 2px;
  &-img {
    user-select: none;
  }
}

.item-wrap {
  align-items: center;
  justify-content: space-between;
  line-height: 32px;
}

.card-content {
  display: flex;
  margin-top: 16px;
  padding: 0px 10px;
  box-sizing: border-box;
  .card-box {
    width: 388px;
    height: 257px;
    padding: 30px 30px !important;
    box-shadow: 0px 3px 10px 1px rgba(31, 66, 135, 0.15);
    border-radius: 8px 8px 8px 8px;
    margin: 0 20px 20px 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .card-box:nth-child(4n) {
    @media (min-width: 1510px) and (max-width: 1920px) {
      margin: 0 20px 20px 0;
    }

    @media (min-width: 2325px) {
      margin: 0 20px 20px 0;
    }

    @media (min-width: 1919px) and (max-width: 2324px) {
      margin-right: 0px;
    }
  }
  .card-box:hover,
  .card-box.focus {
    -webkit-box-shadow: 0px 0px 30px 0px rgba(31, 66, 135, 0.15);
    box-shadow: 0px 3px 10px 1px rgba(31, 66, 135, 0.15);
    -webkit-transform: translate(0, -12px);
    transform: translate(0, -12px);
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
}

.onbtn {
  width: 52px;
  min-width: 52px;
  height: 21px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #00c455;
  font-size: 12px !important;
  color: #00c455;
  line-height: 21px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}
.offbtn {
  min-width: 52px;
  width: 52px;
  height: 21px;
  border-radius: 4px;
  border: 1px solid #cccccc;
  color: #cccccc;
  font-size: 12px !important;
  padding: 0 !important;
  line-height: 21px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}
</style>
